import React, { useEffect, useRef, useState } from 'react'
import './profile.styles.scss'

import ProfileIcon from './profile-icon.component'
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { setUserProfile } from '@/state/slices/userSlice';
import flatpickr from 'flatpickr'

import logo_long from '@/assets/logo_long.png';
import Footer from '@/components/layout-unauth/footer/footer.component';
import { ModalAlert } from '@/components/modal/modal.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import { getRandomLinearGradient } from '@/utils/randomGradient';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { RandomString } from '@/utils/randomString';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import InfoLinks from '@/components/SHARED/info-links/info-links.component';
import useAnalytics from '@/utils/useAnalytics';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import FullPageLoader from '@/components/loader/full-page-loader.component';

const ProfilePage = () => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const currentUser = useSelector(state => state.userData.currentUser);
  const userProfile = useSelector(state => state.userData.userProfile);
  const membership = useSelector(state => state.userData.membership);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [fp, setFp] = useState(null);
  const [ofAge, setOfAge] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);
  const [lockBirthday, setLockBirthday] = useState(false);
  const [ selectedPlan, setSelectedPlan] = useState(null);
  const { joinCode } = useParams();
  const { trackEvent, trackException } = useAnalytics();
  const dataRef = useRef();
  const birthdayRef = useRef();
  const fpRef = useRef();
  let fpObj;
  const storage = getStorage();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const monthsData = [
    {
      "month": "January",
      "days": 31,
    },
    {
      "month": "February",
      "days": 29,
    },
    {
      "month": "March",
      "days": 31,
    },
    {
      "month": "April",
      "days": 30,
    },
    {
      "month": "May",
      "days": 31,
    },
    {
      "month": "June",
      "days": 30,
    },
    {
      "month": "July",
      "days": 31,
    },
    {
      "month": "August",
      "days": 31,
    },
    {
      "month": "September",
      "days": 30,
    },
    {
      "month": "October",
      "days": 31,
    },
    {
      "month": "November",
      "days": 30,
    },
    {
      "month": "December",
      "days": 31,
    }
  ];

  useEffect(() => {
    changeDocumentTitle();
    // populateDateSelectors();
  }, [])

  useEffect(() => {
    if (userProfile) {
      console.log(userProfile);
      dataRef.current = userProfile;
      if (!dataRef.current.gradient) {
        dataRef.current = {
          ...dataRef.current,
          gradient: getRandomLinearGradient()
        };
      }
      setFormData(dataRef.current);
      if (userProfile.birthday) {
        setLockBirthday(true);
      } else {
        setLockBirthday(false);
      }
      // birthdayRef.current = {
      //   month: new Date(userProfile.birthday).getMonth() + 1,
      //   day: new Date(userProfile.birthday).getDate(),
      //   year: new Date(userProfile.birthday).getFullYear(),
      // }
    } 
    // else {
    //   const tempProfile = JSON.parse(window.localStorage.getItem('tempProfile'));
    //   if (tempProfile) {
    //     tempProfile.gradient = getRandomLinearGradient();
    //     dataRef.current = tempProfile;
    //     setFormData(dataRef.current);
    //   }
    // }
  }, [userProfile])

  useEffect(() => {
    populateDateSelectors();
  }, [formData])

  useEffect(() => {
    if (!currentUser) { 
      navigate('/logout');
      return;
    }
    saveData('email', currentUser.email);
    saveData('fName', currentUser.displayName ? currentUser.displayName.split(' ')[0] : '');
    saveData('lName', currentUser.displayName ? currentUser.displayName.split(' ').slice(1).join(' ') : '');
  }, [currentUser])

  function saveData(key, value) {
    if (key === 'legalApproved' && value) {
      value = new Date().getTime();
    }
    dataRef.current = { ...dataRef.current, ...{ [key]: value } };
    setFormData(dataRef.current);
  }

  function saveBirthday(key, value) {
    birthdayRef.current = { ...birthdayRef.current, ...{ [key]: value } };
    console.log(birthdayRef.current);
    if (birthdayRef.current.month && birthdayRef.current.day && birthdayRef.current.year) {
      const birthdayDate = new Date(`${birthdayRef.current.year}-${birthdayRef.current.month}-${birthdayRef.current.day}`).getTime();
      saveData('birthday', birthdayDate);
      var month_diff = Date.now() - birthdayDate;  
      var age_dt = new Date(month_diff);
      var year = age_dt.getUTCFullYear();  
      var age = Math.abs(year - 1970);
      if (age >= 16) {
        setOfAge(true);
      } else {
        setOfAge(false);
      }
    }
  }

  function populateDateSelectors() {
    const monthSelect = document.getElementById('month-select');
    monthSelect.innerHTML = '<option value="">Select Month</option>'; // Clear previous months
    const daySelect = document.getElementById('day-select');
    daySelect.innerHTML = '<option value="">Select Day</option>'; // Clear previous days
    const yearSelect = document.getElementById('year-select');
    yearSelect.innerHTML = '<option value="">Select Year</option>'; // Clear previous years

    // Populate months
    for (const month in monthsData) {
      const option = document.createElement('option');
      option.value = Number(month) + 1;
      option.textContent = monthsData[month].month;
      monthSelect.appendChild(option);
    }

    // Populate years (e.g., from 1950 to current year)
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 1950; year--) {
      const option = document.createElement('option');
      option.value = year;
      option.textContent = year;
      yearSelect.appendChild(option);
    }
    monthSelect.addEventListener('change', populateDays);
    yearSelect.addEventListener('change', populateDays);

    // Initial call to populate days when the page loads
    populateDays();

    if (formData.birthday) {
      console.log(formData.birthday);
      const bday = new Date(formData.birthday);
      console.log(bday.getMonth() + 1);
      monthSelect.value = bday.getMonth() + 1;
      daySelect.value = bday.getDate();
      yearSelect.value = Number(bday.getFullYear());
      // displayBirthday(new Date(formData.birthday));
    }

    function populateDays() {
      daySelect.innerHTML = '<option value="">Select Day</option>'; // Clear previous days

      const selectedMonth = monthSelect.value || 1;
      const selectedYear = yearSelect.value;
      // let daysInMonth = 0;
      let daysInMonth = monthsData[selectedMonth - 1].days;

      // Handle February and leap years
      if (selectedMonth === "2" && selectedYear) {
        const isLeapYear = (selectedYear % 4 === 0 && selectedYear % 100 !== 0) || (selectedYear % 400 === 0);
        daysInMonth = isLeapYear ? 29 : 28;
      }

      // Populate days
      if (daysInMonth) {
        for (let i = 1; i <= daysInMonth; i++) {
          const option = document.createElement('option');
          option.value = i;
          option.textContent = i;
          daySelect.appendChild(option);
        }
      }
      if (birthdayRef.current?.day) {
        daySelect.value = birthdayRef.current.day;
      }
      
    }
  }

  function saveBio(text) {
    const length = text.length;
    const count = document.getElementById('word-count')
    if (length <= 200) {
      count.innerHTML = `${length}/200`
      saveData('bio', text)
    }
  }

  async function handleSubmit() {
    if (!formData.fName || !formData.lName || !formData.birthday) {
      setAlertMessage('Please include your name and your birthday before saving your profile.')
      return;
    }
    if (!formData.legalApproved) {
      setAlertMessage('Please accept the Terms of Service and Privacy Policy before saving your profile.')
      return;
    }
    if (formData.ts === formData.ts_joined && !selectedPlan && ofAge) {
      setAlertMessage('Please select a membership plan before saving your profile.')
      return;
    }
    if (!formData.icon) {
      saveProfile(null)
      return;
    }
    if (formData.icon.upload && formData.icon.type.indexOf('gif') == -1) {
      formData.icon.croppie.result({
        type: 'blob',
        size: { 'width': 128, 'height': 128 },
        quality: 0.05,
      })
        .then((blob) => {
          uploadImage(formData.icon, blob)
          return;
        })
    } else if (formData.icon.upload) {
      uploadImage(formData.icon, formData.icon.file)
      return;
    } else if (formData.icon.url) {
      saveProfile(formData.icon.url)
      return;
    } else if (formData.icon) {
      saveProfile(formData.icon)
    } else {
      saveProfile();
    }
  }

  function uploadImage(profileIcon, blob) {
    const now = new Date().getTime();
    const profileRef = ref(storage, `uploaded-profile-icons/${now}-${formData.icon.name}`);
    const metadata = {
      contentType: formData.icon.type,
      customMetadata: {
        appId: userProfile.appId ?? currentUser.uid,
        email: formData.email
      }
    };
    uploadBytes(profileRef, blob, metadata).then((snapshot) => {
      getDownloadURL(profileRef)
        .then((url) => {
          saveProfile(url);
          UseCloudFunction(
            'saveToMyContent',
            {
              'appId': userProfile.appId,
              'source': 'Profile Icons',
              'category': 'Images',
              'cropped': true,
              'contentData': {
                'name': formData.icon.name,
                'url': url,
                'type': 'image',
                'id': `${now}_${RandomString(10)}_image`
              },
            }
          )
          return;
        })
    })
  }

  const saveProfile = async (url) => {
    let tempData = { ...dataRef.current };
    setLoading(true)
    let appId;
    if (!userProfile && !tempData.appId) {
      appId = currentUser.uid;
    } else if (userProfile) {
      appId = userProfile.appId;
    } else {
      appId = tempData.appId;
    }
    const now = new Date().getTime();
    if (!tempData.ts_created) {
      tempData.ts_created = now;
    }
    const profile = {
      ...tempData,
      ...{
        appId: appId,
        email: currentUser.email,
        name: `${tempData.fName} ${tempData.lName}`,
        ts: now,
        uid: currentUser.uid,
        status: 'active',
      }
    }

    if (url) {
      profile.icon = url;
    }
    if (!tempData.ts_joined) {
      profile.ts_joined = now;
    }

    const res = await UseCloudFunction('saveProfile', { 'profile': profile })
    if (res.success) { 
      window.localStorage.removeItem('tempProfile');
      dispatch(setUserProfile(profile));
      let event = 'profile_saved';
      if (tempData.ts_created === now) {
        event = 'profile_created';
      }
      trackEvent(
        event, 
        'User', 
        `User ${profile
            ? profile.appId
            : 'Guest'
          } saved their profile.`, 
        null, 
        membership.membership ?? 'Unknown'
      );
      setLoading(false);
      if (
        !ofAge ||
        !selectedPlan ||
        selectedPlan === 'free'
      ) {
        const to = setTimeout(() => {
          navigate(`/loading${joinCode ? `/${joinCode}` : ''}`);
          console.log('navigating to loading page');
          clearTimeout(to);
          return;
        }, 1000)
      } else {
        goToPurchasePage();
        return;
      }
    } else {
      setAlertMessage('Something went wrong. Try again later.');
      trackException(`Profile Save Error: ${res.error}`);
      setLoading(false);
      return;
    }
    
  }

  async function goToPurchasePage() {
    console.log('navigating to purchase page');
    navigate(`/purchase/${selectedPlan}monthly`);
  }

  return (
    <div >
      <UnauthLayout>
        <div className='profile-page'>
          <div className={`profile-form ${screenSize}`}>
            <div className='g-card'>
              <div className='card-head'>
                <span>Create a Profile</span>
                <img src={logo_long} className='profile-logo' />
              </div>
              <hr />
              <div className='g-grid'>
                <div className="g-half-col">
                  <div className="field small">
                    <label>First Name</label>
                    <input
                      type='text'
                      value={formData.fName ?? ''}
                      onChange={(e) => saveData('fName', e.target.value)} />
                  </div>
                </div>
                <div className="g-half-col">
                  <div className="field small">
                    <label>Last Name</label>
                    <input
                      type='text'
                      value={formData.lName ?? ''}
                      onChange={(e) => saveData('lName', e.target.value)} />
                  </div>
                </div>
              </div>
              <div className="g-space-1"></div>
              <div className='field small'>
                <label>Email</label>
                <input
                  type='text'
                  className='disabled'
                  defaultValue={formData.email}
                  disabled />
              </div>

              <hr />
              <h3>On what day were you born?</h3>
              <p>We use this information to help keep our users safe. Check out
                our <a
                  href="/info/privacy"
                  target="_blank">
                  Privacy Policy
                </a> for more information.</p>
              <div className={`date-selector ${lockBirthday ? 'disabled' : ''} ${screenSize}`}>
                <div className='field small'>
                  <label htmlFor="month-select">Month:</label>
                  <select
                    id="month-select"
                    onChange={(e) => saveBirthday('month', e.target.value)}>
                    <option value="">Select Month</option>
                  </select>
                </div>
                <div className='field small'>
                  <label htmlFor="day-select">Day:</label>
                  <select
                    id="day-select"
                    onChange={(e) => saveBirthday('day', e.target.value)}>
                    <option value="">Select Day</option>
                  </select>
                </div>
                <div className='field small'>
                  <label htmlFor="year-select">Year:</label>
                  <select
                    id="year-select"
                    onChange={(e) => saveBirthday('year', e.target.value)}>
                    <option value="">Select Year</option>
                  </select>
                </div>
              </div>

              {
                (formData.birthday) &&
                <>
                  <hr />
                  <ProfileIcon
                    formData={formData}
                    saveData={saveData}
                    ofAge={ofAge} />

                  {/* <div className="g-space-2"></div> */}
                  {/* <div className='field'>
                                <label>Tell us about you</label>
                                <textarea defaultValue={formData.bio ? formData.bio : ''} onChange={(e) => saveBio(e.target.value)}></textarea>
                                <div id='word-count'>0/200</div>
                            </div> */}
                  
                  
                  {
                    (ofAge && userProfile.ts === userProfile.ts_joined) &&
                    <>
                    <hr />
                    <h3>Choose a Membership Plan</h3>
                    <p>You can choose a membership plan that best fits your needs. 
                      If you choose a monthly subscription, you will receive your 
                      first THREE MONTHS for FREE!
                    </p>
                    <div className={`plan-list ${screenSize}`}>
                      <button 
                        className={`g-button ${selectedPlan === 'free' ? 'selected' : ''}`}
                        onClick={() => setSelectedPlan('free')} >
                        <ImageContainer
                          src='/images/icons/free.png'
                          className='plan-icon'
                          // containerHeight="98px"
                          containerWidth="60px" />
                        <div className='button-text'>
                          <div className='plan-name'>Free Plan</div>
                          <div className='plan-price'>$0 per month</div>
                          <div className="g-space-0-5"></div>
                          <div className='meta'>Access to limited features with limited usage.</div>
                        </div>
                      </button>
                      <button 
                        className={`g-button ${selectedPlan === 'pro' ? 'selected' : ''}`}
                        onClick={() => setSelectedPlan('pro')} >
                        <ImageContainer
                          src='/images/icons/pro.png'
                          className='plan-icon'
                          // containerHeight="98px"
                          containerWidth="60px" />
                        <div className='button-text'>
                          <div className='plan-name'>Pro Plan</div>
                          <div className='plan-price'>$3 per month</div>
                          <div className="g-space-0-5"></div>
                          <div className='meta'>Full access to all features with limited usage.</div>
                        </div>
                      </button>
                      <button 
                        className={`g-button ${selectedPlan === 'premium' ? 'selected' : ''}`}
                        onClick={() => setSelectedPlan('premium')} >
                        <ImageContainer
                          src='/images/icons/premium.png'
                          className='plan-icon'
                          // containerHeight="98px"
                          containerWidth="60px" />
                        <div className='button-text'>
                          <div className='plan-name'>Premium Plan</div>
                          <div className='plan-price'>$6 per month</div>
                          <div className="g-space-0-5"></div>
                          <div className='meta'>Full access to all features with unlimited usage.</div>
                        </div>
                      </button>
                    </div>
                    </>
                  }

                  {/* <div className='field'>
                    <label>Optional: For what purpose are you planning to use this website?</label>
                    <select
                      value={formData.purpose ?? ''}
                      onChange={e => saveData('purpose', e.target.value)}>
                      <option
                        value='' disabled>
                        Please choose an option...
                      </option>
                      <option
                        value='Education/Classroom Use'>
                        Education/Classroom Use
                      </option>
                      <option
                        value='Education/Professional Development'>
                        Education/Professional Development
                      </option>
                      <option
                        value='Personal Use'>
                        Personal Use
                      </option>
                      <option
                        value='Business'>
                        Business
                      </option>
                      <option
                        value='For Fun!'>
                        For Fun!
                      </option>
                      <option
                        value='Other'>
                        Other
                      </option>
                    </select>
                  </div> */}
                  {/* <div className='g-space-2'></div>
                  <div className='field'>
                    <label>Optional: If you are part of a school or business, what is its name?</label>
                    <input
                      type='text'
                      defaultValue={
                        formData.school
                          ?
                          formData.school
                          : ''}
                      onChange={(e) => saveData('school', e.target.value)} />
                  </div> */}
                  {
                    (!userProfile || !userProfile.legalApproved) &&
                    <>
                      <div className="g-space-2"></div>
                      <div className='field-checkbox'>
                        <input
                          type='checkbox'
                          id='legal-approval'
                          defaultChecked={formData.legalApproved ? true : false}
                          onChange={(e) => saveData('legalApproved', e.target.checked)} />
                        <label>
                          <p>
                            I acknowledge that I have read and I understand
                            the <a href='/terms' target="_blank">Terms of Service</a> and
                            the <a href='/privacy' target="_blank">Privacy Policy</a>, and
                            I agree to be bound by them.
                          </p>
                        </label>
                      </div>
                    </>
                  }
                </>
              }
              <hr />
              <div className='buttons'>
                {
                  (userProfile && !loading) &&
                  <button
                    className={`g-button ${screenSize === 'mobile'
                        ? 'med-btn'
                        : ''
                      }`}
                    onClick={() => navigate(-1)}>
                    Cancel
                  </button>
                }
                {
                  (!loading)
                    ?
                    <button
                      className={`g-button save-profile-button primary ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`}
                      onClick={() => handleSubmit()}>
                      Save Your Profile
                    </button>
                    :
                    <button
                      className={`g-button save-profile-button disabled ${screenSize === 'mobile'
                          ? 'med-btn'
                          : ''
                        }`} >
                      <ThreeDotsLoader />
                    </button>
                }
              </div>
            </div>
            {/* <LandingPage /> */}
            <ModalAlert
              show={alertMessage}
              cancel={() => setAlertMessage(false)}
              message={alertMessage} />

          </div>
          <InfoLinks />
          <div className="g-space-1"></div>
        </div>
      </UnauthLayout>
      <FullPageLoader show={loading} />
    </div>
  )
}

export default ProfilePage